export default __webpack_public_path__ + "static/icp-cat-logo-d6dbe8a771265e218fca68aa8e6a84dc.png";